import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TextField } from 'redux-form-material-ui';
import {
  Field, change, Form, formValueSelector,
} from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { FORM_NAME, FORM_DEFINITION } from './index';
import { getCompanyById, save } from '../../../redux/actions/companyActions';

import CNPJNormalize from './../../normalize/CNPJNormalize';


const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = state => ({
  companyData: state.companyReducer.companyData,
  companyId: state.companyReducer.companyId,
  values: formSelector(state, 'id', 'name'),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getCompanyById,
  save,
}, dispatch);


export class CompanyForm extends Component {

    static propTypes = {

    };

    static defaultProps = {

    };

    constructor(props) {

      super(props);

      this.onSubmit = this.onSubmit.bind(this);
      this.setFormValues = this.setFormValues.bind(this);

    }

    componentDidMount() {

      const { reset, companyId, get, getCompanyById } = this.props;

      reset();

      if (companyId) getCompanyById(companyId).then((data) => {

        this.setFormValues(data);

      });


    }

    onSubmit(data) {

      const { save, dispatch } = this.props;

      return save(data).then(() => true, (errors) => {

        throw errors;

      });

    }

    setFormValues(values) {

      const { dispatch } = this.props;

      Object.keys(values).forEach((key) => {

        let value = '';
        switch (key) {

          case 'dateCreated':
            value = new Date(values[key]);
            break;

          default:
            value = values[key];

        }

        dispatch(change(FORM_NAME, key, value));

      });

    }

    render() {

      const {
        submitting,
        handleSubmit,

      } = this.props;

      return (

        <div>
          <Form form={FORM_NAME} onSubmit={handleSubmit(this.onSubmit)}>

            <div>
              <Field
                name="name"
                component={TextField}
                label={I18n.t('fields.name')}
                fullWidth
                disabled={submitting}
              />

              <Field
                name="cnpj"
                component={TextField}
                label={I18n.t('fields.cnpj')}
                fullWidth
                normalize={CNPJNormalize}
                disabled={submitting}
              />

            </div>

          </Form>

        </div>
      );

    }
}


export default FORM_DEFINITION(
  connect(mapStateToProps, mapDispatchToProps)(CompanyForm),
);



// WEBPACK FOOTER //
// ./src/components/tracker/Company/CompanyReduxForm.js